import comp from './UserProfile'
export default comp
